class WithdrawalFormController {
  constructor() {
    this.form = document.getElementById('EuWithdrawalForm');
    if (!this.form) return;

    this.reviewBtn = document.getElementById('review-details-btn');
    this.editBtn = document.getElementById('back-to-edit-btn');
    this.submitBtn = document.getElementById('submit-withdrawal-btn');

    if (!this.reviewBtn || !this.editBtn || !this.submitBtn) return;

    this.stepOne = document.getElementById('step-one-container');
    this.stepTwo = document.getElementById('step-two-container');
    this.successState = document.getElementById('success-container');

    this.nameInput = document.getElementById('WithdrawalName');
    this.emailInput = document.getElementById('WithdrawalEmail');
    this.orderInput = document.getElementById('WithdrawalOrderNumber');

    this.summaryName = document.getElementById('summary-name');
    this.summaryEmail = document.getElementById('summary-email');
    this.summaryOrder = document.getElementById('summary-order');

    // Live Firebase Cloud Function Endpoint
    this.functionUrl = 'https://europe-west1-eduline-shopify-tools.cloudfunctions.net/euContractWithdrawal';

    this.bindEvents();
  }

  bindEvents() {
    this.reviewBtn.addEventListener('click', () => this.handleReview());
    this.editBtn.addEventListener('click', () => this.handleEdit());
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  handleReview() {
    if (!this.form.reportValidity()) return;

    this.summaryName.textContent = this.nameInput.value;
    this.summaryEmail.textContent = this.emailInput.value;
    this.summaryOrder.textContent = this.orderInput.value;

    this.stepOne.style.display = 'none';
    this.stepTwo.style.display = 'block';
  }

  handleEdit() {
    this.stepTwo.style.display = 'none';
    this.stepOne.style.display = 'block';
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = 'Processing...';

    const payload = {
      name: this.nameInput.value,
      email: this.emailInput.value,
      order_number: this.orderInput.value
    };

    try {
      const response = await fetch(this.functionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Network response was not ok');
      }

      this.form.style.display = 'none';
      this.successState.style.display = 'flex';

    } catch (error) {
      console.error('Error submitting withdrawal:', error);
      alert('There was a problem submitting your request. Please try again.');
      this.submitBtn.disabled = false;
      this.submitBtn.textContent = 'Confirm withdrawal';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new WithdrawalFormController();
});